import { type RowData, type TableFeature } from "@tanstack/react-table";

interface ClickRowTitleTableOptions<T> {
  onClickRowTitle?: (row: T) => void;
}

interface ClickRowTitleRowOptions<T> {
  clickRowTitle: (row: T) => void;
}

declare module "@tanstack/react-table" {
  /* eslint-disable-next-line @typescript-eslint/no-empty-interface */
  interface TableOptionsResolved<TData extends RowData>
    extends ClickRowTitleTableOptions<TData> {}
  /* eslint-disable-next-line @typescript-eslint/no-empty-interface */
  interface Row<TData extends RowData> extends ClickRowTitleRowOptions<TData> {}
}

export const ClickRowTitleFeature: TableFeature = {
  createRow: (row, table): void => {
    row.clickRowTitle = (value) => {
      table.options.onClickRowTitle?.(value);
    };
  },
};
